/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Rule_Amount_Range_InvalidInputs */

const vi_expense_rule_amount_range_invalid = /** @type {(inputs: Expense_Rule_Amount_Range_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền đến phải lớn hơn hoặc bằng số tiền từ`)
};

/**

* @param {Expense_Rule_Amount_Range_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_rule_amount_range_invalid = /** @type {((inputs?: Expense_Rule_Amount_Range_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Rule_Amount_Range_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_rule_amount_range_invalid(inputs)
});